import {
  BannerInlinePlaceholder,
  IBannerInlinePlaceholderProps,
} from '@tekface/smart-activation';
import { getTrackingData } from '@teko/tracking';
import React from 'react';

interface InlineBannerProps {
  inlineBanners?: IBannerInlinePlaceholderProps<{}>['banners'];
  inlineBannerClass: string;
}

export const InlineBanner: React.FC<InlineBannerProps> = ({
  inlineBanners,
  inlineBannerClass,
}) => {
  return (
    <BannerInlinePlaceholder
      isNewWrapper={true}
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'inline-banner',
      })}
      banners={inlineBanners}
      className={inlineBannerClass}
    />
  );
};
